import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["style"],
  _excluded2 = ["lineHeight", "transform"],
  _excluded3 = ["accessibilityLabel", "inputRef", "keyboardType", "onPress", "tabIndex", "testID"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { prefixStyle } from '@lada/prefix';
import styleTransformArrayToText from '@bubble-ui/util-style-transform-array-to-text';
import systemFontsDefaultLetterSpacing from '@bubble-ui/particle-system-fonts-default-letter-spacing';
import { useDesignContext } from '@klarna/designtokens';
import defaultColorVariables from '@bubble-ui/particle-default-color-variables';
var TextInput = _ref => {
  var {
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = style || {},
    {
      lineHeight,
      transform
    } = _ref2,
    restOfStyle = _objectWithoutProperties(_ref2, _excluded2);
  var {
      accessibilityLabel,
      inputRef,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      keyboardType,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onPress,
      tabIndex,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      testID
    } = props,
    inputProps = _objectWithoutProperties(props, _excluded3);
  var additionalProps = {
    onChange: e => {
      var _props$onChange;
      return (!props.disabled || !props.readOnly) && ((_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, e.target.value, e));
    }
  };
  var designContext = useDesignContext(defaultColorVariables);
  var letterSpacing = restOfStyle.letterSpacing ? restOfStyle.letterSpacing : systemFontsDefaultLetterSpacing(Number(restOfStyle.fontSize));
  return /*#__PURE__*/React.createElement("input", _extends({
    style: prefixStyle(_objectSpread(_objectSpread(_objectSpread({
      backgroundColor: designContext.get('colors/backgrounds/transparent').toString(),
      border: 'none',
      boxSizing: 'border-box',
      outline: 'none',
      width: '100%'
    }, restOfStyle), {}, {
      letterSpacing: "".concat(letterSpacing, "px"),
      fontSmoothing: 'antialiased',
      textRendering: 'geometricPrecision'
    }, lineHeight && {
      lineHeight: "".concat(lineHeight, "px")
    }), transform && {
      transform: styleTransformArrayToText(transform)
    })),
    "aria-label": accessibilityLabel,
    ref: inputRef,
    tabIndex: tabIndex
  }, inputProps, additionalProps));
};
export default TextInput;
//# sourceMappingURL=index.js.map